import React from "react";

/**
 * This function is used to detect any citation exists in the text , i.e [1], [2]
 * @param text text string which may contain citation
 * @returns React Component: formatted text inside sup element with onClick function
 */
export function parseCitations(text: string): React.ReactNode[] {
  const parts = text.split(/(\[\d+\])/g);
  return parts.map((part, index) => {
    const match = part.match(/\[(\d+)\]/);
    if (match) {
      const citationId = match[1];
      return (
        <sup
          key={index}
          className="citation-link"
          onClick={() => {
            const ref = document.getElementById(`citation-${citationId}`);
            if (ref) ref.scrollIntoView({ behavior: "smooth", block: "center" });
          }}
          style={{
            color: "#d4af37",
            cursor: "pointer",
            fontWeight: 600,
            marginLeft: "2px",
          }}
          data-citation={citationId}
        >
          [{citationId}]
        </sup>
      );
    }
    return part;
  });
}
